import AdminLoadable from 'components/core/AdminLoadable';
import type { IEditLogoBarProps } from './EditLogoBar';

export default AdminLoadable<IEditLogoBarProps>({
  loader: () => import('./EditLogoBar'),
  name: 'EditLogoBar',
});
